import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const previousAppointmentsSettings = {
  stateName: 'previousAppointments',
  dataType: 'object',
  actions: {
    fetch: 'ducks/clients/FETCH_PREVIOUS_APPOINTMENTS',
  },
};

// Action Creators
export function fetchPreviousAppointments(
  params = '',
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    previousAppointmentsSettings.actions.fetch,
    'get',
    `${API_URL}/practice/appointments/paginated_index?previous=true${params}`,
    {},
    true,
    callback,
    errorCallback,
  );
}
